import { render } from "./CompanyData.vue?vue&type=template&id=5e411e16&scoped=true"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"

import "./CompanyData.vue?vue&type=style&index=0&id=5e411e16&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e411e16"]])

export default __exports__